import { DEFAULT_GROUPBY_HEADER_LABEL_HEIGHT, DEFAULT_ITEM_HEIGHT, DEFAULT_ITEM_HEIGHT_COMPACT, DEFAULT_ITEM_HEIGHT_WITH_SUBTITLE, DEFAULT_ITEM_HEIGHT_WITH_SUBTITLE_COMPACT, } from '../dropdown.constants';
export function getVirtualizedOptionHeight(opt, virtualizeProps) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var groupByHeaderHeight = (_b = (_a = virtualizeProps.heights) === null || _a === void 0 ? void 0 : _a.groupByHeader) !== null && _b !== void 0 ? _b : DEFAULT_GROUPBY_HEADER_LABEL_HEIGHT;
    var optionHeight = (_d = (_c = virtualizeProps.heights) === null || _c === void 0 ? void 0 : _c.option) !== null && _d !== void 0 ? _d : DEFAULT_ITEM_HEIGHT;
    var optionCompactHeight = (_f = (_e = virtualizeProps.heights) === null || _e === void 0 ? void 0 : _e.optionCompact) !== null && _f !== void 0 ? _f : DEFAULT_ITEM_HEIGHT_COMPACT;
    var optionWithSubtitleHeight = (_h = (_g = virtualizeProps.heights) === null || _g === void 0 ? void 0 : _g.optionWithSubtitle) !== null && _h !== void 0 ? _h : DEFAULT_ITEM_HEIGHT_WITH_SUBTITLE;
    var optionCompactWithSubtitleHeight = (_k = (_j = virtualizeProps.heights) === null || _j === void 0 ? void 0 : _j.optionWithSubtitleCompact) !== null && _k !== void 0 ? _k : DEFAULT_ITEM_HEIGHT_WITH_SUBTITLE_COMPACT;
    if (typeof opt === 'string')
        return groupByHeaderHeight;
    var hasSubtitle = Boolean(opt.subtitle);
    var height = optionHeight;
    if (virtualizeProps.compact) {
        if (hasSubtitle)
            height = optionCompactWithSubtitleHeight;
        else
            height = optionCompactHeight;
    }
    else if (hasSubtitle)
        height = optionWithSubtitleHeight;
    return height;
}
